import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "webcrypto-shim";
import "polyfill-array-includes";
import "bluebird";
import React, { useState } from "react";
import AppRoutes from "./app.routes";
import "bootstrap/dist/css/bootstrap.min.css";
import "astm-ux-design-system/dist/bundle.css";
import "assets/themes/main.css";
import CustomLoader from "shared-components/Loader";
import CustomAlert from "shared-components/Alert";
import SafariAutofillMessage from "./shared-components/SafariAutoFillMessage";
import { useOktaAuth, withOktaAuth } from "@okta/okta-react";
import {
  checkSessionHandler,
  getIdentityDelegation,
  OIDC,
  logoutHandler,
  isStaticPageHandler
} from "helpers/OktaUtility";
import {
  SESSION_STORAGE_KEYS,
} from "models/common.models";
import { useDispatch, useSelector } from "react-redux";
import { setAuthorised, setFeatureFlag, setLoader, setUserInfo } from "common.actions";
import { useHistory, useLocation } from "react-router-dom";
import { cacheManager } from "helpers/util-common";

const App = (props) => {
  const {
    loading,
    showToastMessage,
    content,
    isSafariAutoFillInfoVisible,
    setSafariAutoFillInfo,
    uuidNumber,
    getFeatureFlagData
  } = props;
  const [isMemberStillLoginInAnotherTab, setIsMemberStillLoginInAnotherTab] =
    React.useState("");
  const [identityDelegation, setIdentityDelegation] = React.useState(null);
  const dispatch = useDispatch();
  const oktaAuth = useOktaAuth();
  const history = useHistory();
  const location = useLocation();
  const commonReducer= useSelector((common)=>common?.commonReducer);
  const IsAuthorised = commonReducer?.IsAuthorised;
  const isFeatureFlag = commonReducer?.featureFlag;
  const hasMAEUserID = commonReducer?.userInfo?.MAEUserID;
  const [isAppLoad, setIsAppLoad] = useState(false)

  const loadOKTAConfiguration = () => {
    // To validate callback and session exist in application.
    OIDC.tokenManager.get("idToken").then((tokenInfo) => {
      if (tokenInfo) {
        dispatch(setUserInfo(tokenInfo.claims));
        dispatch(setAuthorised(true));
        dispatch(setLoader(false));
        const REDIRECT_CALLBACK_URL = sessionStorage.getItem(
          SESSION_STORAGE_KEYS.REDIRECT_CALLBACK_URL
        );
        if (REDIRECT_CALLBACK_URL) {
          history.push(REDIRECT_CALLBACK_URL);
          sessionStorage.removeItem(SESSION_STORAGE_KEYS.REDIRECT_CALLBACK_URL);
          sessionStorage.removeItem(SESSION_STORAGE_KEYS.STATIC_REDIRECT_URL);
        }
      }
    });
  };

  React.useEffect(() => {
    if (IsAuthorised && hasMAEUserID) {
      setIsAppLoad(true);
    }
  }, [IsAuthorised, hasMAEUserID]);

  React.useEffect(() => {
    loadOKTAConfiguration();
    const identityDelegationExisted = getIdentityDelegation();
    setIdentityDelegation(identityDelegationExisted);
    
    window.addEventListener("storage", (e) => {
      if (e.key === "isMemberStillLoginInAnotherTab" && e.newValue === 'false') {
        logoutHandler()
      }
      if(e.key === 'user-info' && e.oldValue !== e.newValue){
        const identityDelegationNew = getIdentityDelegation();
        if (identityDelegationNew) {
          const prevIdentityDelegationValue = identityDelegation;
          if (
            !prevIdentityDelegationValue ||
            prevIdentityDelegationValue.proxyMemberMAEUserId !==
            identityDelegationNew.proxyMemberMAEUserId
          ) {
            window.location.replace(window.location.origin);
          }
        }
      }
    });
  }, []);

  React.useEffect(() => {
    if (oktaAuth?.authState?.isAuthenticated) {
      loadOKTAConfiguration();
    }else{
      setIsAppLoad(true);
      dispatch(setLoader(false));
    }
  }, [oktaAuth]);

  React.useEffect(() => {
    if(!IsAuthorised){
      checkSessionHandler(location);

      //Get FeatureFlag if no session and public page
      const staticPageUrl = isStaticPageHandler(location)
      const featureFlagLocal =  cacheManager.getItem("flagFeature")
      if(staticPageUrl && !featureFlagLocal) {
        getFeatureFlagData(dispatch)
      } else if(!staticPageUrl) {
        dispatch(setFeatureFlag(true))
      }
    }
  }, [location, IsAuthorised]);

  return (
    <div className="appWrapper">
      {(loading || !isAppLoad || !isFeatureFlag) && <CustomLoader />}
      {isSafariAutoFillInfoVisible && (
        <SafariAutofillMessage
          setSafariAutoFillInfoHandler={setSafariAutoFillInfo}
        />
      )}
      {showToastMessage && (
        <div className="topAlert">
          <CustomAlert content={content} uuidNumber={uuidNumber} />
        </div>
      )}
      {isAppLoad && isFeatureFlag && <AppRoutes
        {...props}
        isMemberStillLoginInAnotherTab={isMemberStillLoginInAnotherTab}
      /> }
    </div>
  );
};

export default withOktaAuth(App);